import React from 'react';
import './Footer.css';
import Wave from '../../img/wave.png'
import Insta from '@iconscout/react-unicons/icons/uil-instagram';
import Facebook from '@iconscout/react-unicons/icons/uil-facebook';
import Github from '@iconscout/react-unicons/icons/uil-github';
import Messenger from '@iconscout/react-unicons/icons/uil-facebook-messenger';


function Footer() {
  return (
    <div className='footer'>
      <img src={Wave} alt="" style={{width: '100%'}}/>
      <div className="f-content">
        <span className='name'>Kyaw Lwin Soe</span>
        <div className="f-icons">
          <a href="http://instagram.com/kyawlwinsoe812">
          <Insta color='white' size='3rem' />
          </a>
          <a href="https://www.facebook.com/kyawlwinsoe27/"><Facebook color='white' size='3rem'/></a>
          <a href="https://github.com/KyawLwinSoe27/"><Github color='white' size='3rem'/></a>
          <a href=""><Messenger color='white' size='3rem' /></a>
        </div>
       
        <span className='copy'>Powered by Socail Technology Solutions Company Ltd.</span>
      </div>
    </div>
  )
}

export default Footer
